import createEatUp from "@/app";
import MenuApp from "./MenuApp.vue";
import router from "./router";
import { EAT_UP_PAGES } from "@/types";

createEatUp(MenuApp, router, EAT_UP_PAGES.MENU);
